import type { ReactNode } from "react";
import FilterBar from "../UI/FilterBar/FilterBar";
import FilterSection, {
  FilterRangeSection,
} from "../UI/FilterBar/FilterSection";
import type { BalanceFilters } from "../../hooks/use-balance-filters";

interface BalanceFilterBarProps {
  filters: BalanceFilters;
  leftActions?: ReactNode;
}

export default function BalanceFilterBar({
  filters,
  leftActions,
}: BalanceFilterBarProps) {
  return (
    <FilterBar
      searchValue={filters.search}
      onSearchChange={filters.setSearch}
      searchPlaceholder="Rechercher une opération"
      activeFiltersCount={filters.activeFiltersCount}
      onClearFilters={filters.clearFilters}
      leftActions={leftActions}
    >
      <FilterSection
        title="Catégorie"
        options={filters.typeOptions}
        values={filters.typeFilter}
        onChange={filters.setTypeFilter}
        defaultOpen
      />
      <FilterRangeSection
        title="Montant"
        unit="€"
        minValue={filters.montantMin}
        maxValue={filters.montantMax}
        onMinChange={filters.setMontantMin}
        onMaxChange={filters.setMontantMax}
      />
      <FilterRangeSection
        title="Date"
        minLabel="Du"
        maxLabel="Au"
        inputType="date"
        minValue={filters.dateMin}
        maxValue={filters.dateMax}
        onMinChange={filters.setDateMin}
        onMaxChange={filters.setDateMax}
      />
    </FilterBar>
  );
}
